import { CreateReconContractMappingPayload, ReconContractMapping, ReconPhysicalCode, UpdateReconContractMappingPayload } from "../../../Types/ContractMap.type";
import { ImportReconCustomerMappingResponse } from "../../../Types/CustomerMapType";
import axiosInstance from "../../../Utils/axiosInstance";


const LIST_URL = "/paper-app/recon-map-contract/";
const DETAIL_URL = "/paper-app/contract-mapping-detail/";    
const BULK_URL   = "/paper-app/contract-mapping-bulk-delete/";
const PHYSICAL_CODE_RECON_URL = "/paper-app/physical-codes-recon/";
const IMPORT_URL = "/paper-app/import-recon-contract-mapping/";
export const EXPORT_URL = "/paper-app/export-recon-contract-mapping-csv/"

export const fetchReconContractMappings = async (): Promise<
  ReconContractMapping[]
> => {
  const response = await axiosInstance.get<ReconContractMapping[]>(LIST_URL);
  return response.data;
};


export const createReconContractMapping = async (
  payload: CreateReconContractMappingPayload
): Promise<ReconContractMapping> => {
  const response = await axiosInstance.post<ReconContractMapping>(LIST_URL, payload);
  return response.data;
};


export const updateReconContractMapping = async (
  payload: UpdateReconContractMappingPayload
): Promise<ReconContractMapping> => {
  const { id, ...body } = payload;
  const response = await axiosInstance.put<ReconContractMapping>(
    `${DETAIL_URL}${id}/`,
    body
  );
  return response.data;
};

export const deleteReconContractMapping = async (
  id: string
): Promise<void> => {
  await axiosInstance.delete(`${DETAIL_URL}${id}/`);
};

export const importReconContractMappings = async (
  file: File
): Promise<ImportReconCustomerMappingResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosInstance.post<ImportReconCustomerMappingResponse>(
    IMPORT_URL,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const bulkDeleteReconContractMappings = async (
  ids: string[]
): Promise<void> => {
  await axiosInstance.delete(BULK_URL, { data: { ids } });
};

export const fetchReconPhysicalCodes = async (): Promise<ReconPhysicalCode[]> => {
  const response = await axiosInstance.get<ReconPhysicalCode[]>(PHYSICAL_CODE_RECON_URL);
  return response.data;
};